import { render, staticRenderFns } from "./SelectedUserGroupList.vue?vue&type=template&id=18ff2c80&scoped=true&"
import script from "./SelectedUserGroupList.vue?vue&type=script&lang=ts&"
export * from "./SelectedUserGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedUserGroupList.vue?vue&type=style&index=0&id=18ff2c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff2c80",
  null
  
)

export default component.exports